import { render, staticRenderFns } from "./PageFormSelect.vue?vue&type=template&id=bd08c10a&"
import script from "./PageFormSelect.vue?vue&type=script&lang=ts&"
export * from "./PageFormSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports